import classes from "../Styling/SharedStyling.module.css";
import React, { useEffect,  useState } from 'react';
import { useNavigate } from 'react-router-dom';
import thejobhunticon from "../Images/Icons/TJHLogo.png";
import movinghelpericon from "../Images/Icons/MovingGenericV4.png";

export default function MyAppsOverview()
{
  const navigate = useNavigate();

  const [expanded, setExpanded] = useState<boolean>(false)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setExpanded(!expanded);
    }, 2000)
  
    return () => clearInterval(intervalId);
  }, [expanded])

  function imageClassName()
  {
    return expanded ? classes.centeredImgE : classes.centeredImg
  }

  return (
    <div>
      <div className={classes.movingHelperGradient}>
        <header className={classes.fullScreenCenteredContainer}>
          <img alt="" className={classes.backdrop} />
          <div className={classes.centered}><img alt="Moving - Tasks & Items App Icon" className={imageClassName()} src={movinghelpericon} onClick={() => navigate("./movingtasksanditems")} /></div>
        </header>
        </div>
      <div className={classes.theJobHuntGradient}>
      <header className={classes.fullScreenCenteredContainer}>
          <img alt="" className={classes.backdrop} />
          <div className={classes.centered}><img alt="The Job Hunt App Icon" className={imageClassName()} src={thejobhunticon} onClick={() => navigate("./thejobhunt")} /></div>
        </header>
      </div>
    </div>
  );
}
